import { stringifyQuery } from "vue-router";
import Common from "@/util/common.js";
import {
  wareki,
  seireki,
  warekiToYear,
  verifyDate,
  verifyMonth,
  isDate,
  warekisikiiChk,
} from "@/util/dateFormat.js";
import { DETAIL_DURING_DATE_LIST } from "@/util/data.js";
import { transform } from "lodash";
import common from "./common";
import g from "file-saver";

export const validation = {
  /**
   * 西暦 => 和暦
   * @param {*} year 年
   * @returns チェック結果 true  : チェックOK / false : チェックNG
   */
  wareki(year) {
    var eras = [
      { year: 2018, name: "令和" },
      { year: 1988, name: "平成" },
      { year: 1925, name: "昭和" },
      { year: 1911, name: "大正" },
      { year: 1867, name: "明治" },
    ];

    for (const i in eras) {
      const era = eras[i];
      const baseYear = era.year;
      const eraName = era.name;

      if (year > baseYear) {
        var eraYear = year - baseYear;
        if (eraYear === 1) {
          return `${eraName}年度`;
        }
        return `${eraName}${eraYear}年度`;
      }
    }
    return null;
  },
  /**
   * 整数チェック
   * @param {string} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isInteger(input) {
    return this.checkCharType(input, "integer")
  },
  /**
   * 日付正誤チェック
   * @param {number} year 年
   * @param {number} month 月
   * @param {number} day 日
   * @returns チェック結果 true  : チェックOK / false : チェックNG
   */
  verifyDate(year, month, day) {
    if (isNaN(year) || isNaN(month) || isNaN(day)) return false;

    if (month > 12 || month < 1) return false;

    if (day > 31 || day < 1) return false;

    if ((month == 4 || month == 6 || month == 9 || month == 11) && day > 30)
      return false;

    if (month == 2) {
      if (day > 29) return false;
      if (((year % 100 == 0 && year % 400 != 0) || year % 4 != 0) && day > 28) {
        return false;
      }
    }
    return true;
  },

  /**
   * 日付正誤チェック_月日のみ
   * @param {number} month 月
   * @param {number} day 日
   * @returns チェック結果 true  : チェックOK / false : チェックNG
   */
  verifyDateMD(month, day) {
    if (isNaN(month) || isNaN(day)) return false;

    if (month > 12 || month < 1) return false;

    if (day > 31 || day < 1) return false;

    if ((month == 4 || month == 6 || month == 9 || month == 11) && day > 30)
      return false;

    if (month == 2) {
      if (day > 29) return false;
    }
    return true;
  },

  /**
   * 日付正誤チェック
   * @param {number} year 年
   * @param {number} month 月
   * @param {number} day 日
   * @returns 正しい日付かどうか True:正しい日付,False:間違った日付
   */
  checkDate(year, month, day) {
    var validDate = new Date(year, month - 1, day);
    if (
      validDate.getFullYear() == year &&
      validDate.getMonth() == month - 1 &&
      validDate.getDate() == day
    ) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 日付逆転チェック
   * @param {number} startDate 開始日
   * @param {number} endDate 終了日
   * @returns 日付が逆転していないか True:逆転していない,False:逆転している
   */
  checkDueDate(startDate, endDate) {
    if (startDate <= endDate) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 範囲チェック
   * @param {number} input 入力値
   * @param {number} minValue 最小値
   * @param {number} maxValue 最大値
   * @returns チェック結果 true  : チェックOK / false : チェックNG
   */
  checkBetween(input, minValue, maxValue) {
    if (input >= minValue && input <= maxValue) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 日付チェック
   * @param {string} strDate 入力値
   * @returns チェック結果 true  : チェックOK / false : チェックNG
   */
  isDate(strDate) {
    // 空文字は無視
    if (strDate == "") {
      return true;
    }
    // 年/月/日の形式のみ許容する
    if (!strDate.match(/^\d{4}\/\d{1,2}\/\d{1,2}$/)) {
      return false;
    }
    var date = new Date(strDate);
    if (
      date.getFullYear() != strDate.split("/")[0] ||
      date.getMonth() != strDate.split("/")[1] - 1 ||
      date.getDate() != strDate.split("/")[2]
    ) {
      return false;
    }
    return true;
  },

  /**
   * 月チェック
   * @param {number} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isMonth(input) {
    return this.checkBetween(input, 1, 12);
  },

  /**
   * 日チェック
   * @param {number}} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isDay(input) {
    return this.checkBetween(input, 1, 31);
  },

  /**
   * 半角チェック（半角英数字、半角カナ許容）
   * @param {string} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isHalf(input) {
    return /^[\u0020-\u007E\uFF66-\uFF9F]+$/.test(input);
  },

  /**
   * 数字チェック
   * @param {string} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isNumeric(input) {
    return this.checkCharType(input, "numeric");
  },

  /**
   * 英数字チェック
   * @param {string} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isAlphanumeric(input) {
    return this.checkCharType(input, "alphanumeric");
  },

  /**
   * メールアドレスチェック
   * @param {string} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isMail(input) {
    if (input.match(/^[\x00-\xff]*$/)) {
      if (
        input.match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },

  /**
   * 必須チェック
   * @param {} input 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  isRequired(input) {
    if ("" == input) {
      return false;
    } else {
      return true;
    }
  },

  /**
   * パスワードチェック
   *
   * @param {string} id - ユーザーID
   * @param {string} input - 入力されたパスワード
   * @returns {boolean} true: チェックOK / false: チェックNG
   */
  isPassword(id, input) {
    // ・英大文字、英小文字、数字を最低1文字以上使用していること
    // ・8桁以上であること（上限50）
    if (input.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,50}$/)) {
      // ・半角文字であること
      if (this.checkCharType(input, "alphanumeric-symbol")) {
        // ・ログインIDと異なること
        if (id != input) {
          return true; // パスワードが要件を満たしている場合は、true を返す
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  /**
   * 長さチェック
   * @param {string} input 入力値
   * @param {int} Maxlen 入力値
   * @returns Boolean チェック結果 true  : チェックOK / false : チェックNG
   */
  checkMaxLen(input, Maxlen) {
    if (input.length <= Maxlen) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 半角カタカナ含むチェック
   * @param {string} input 入力値
   */
  containsHalfKatakana(input) {
    return input.match(/^(?=.*[\uFF66-\uFF9F].*$)/);
  },

  /*******************************************************************************
        文字列の全角／半角チェック
        @param  input    String  チェック対象文字列
        @param  charType String  チェック種別
        ・"zenkaku"               : 全角文字（ひらがな・カタカナ・漢字 etc.）
        ・"hiragana"              : 全角ひらがな
        ・"katakana"              : 全角カタカナ
        ・"alphanumeric"          : 半角英数字（大文字・小文字）
        ・"numeric"               : 半角数字
        ・"alphabetic"            : 半角英字（大文字・小文字）
        ・"upper-alphabetic"      : 半角英字（大文字のみ）
        ・"lower-alphabetic"      : 半角英字（小文字のみ）
        ・"alphanumeric-plus-other-symbol"      : 半角英数字（大文字・小文字）+特別な記号(._-)
        ・"alphanumeric-symbol"   : 半角英数字（大文字・小文字+記号
        @return Boolean チェック結果OKかどうか
        true  : チェックOK(引数に指定した種別の文字列のみで構成されている)
        false : チェックNG(引数に指定した種別以外の文字列が含まれている)
    *******************************************************************************/
  checkCharType(input, charType) {
    let trimTxt = String(input).replace(/　/g, "");
    switch (charType) {
      // 全角文字（ひらがな・カタカナ・漢字 etc.）
      case "zenkaku":
        return String(input).match(/^[^\x01-\x7E\xA1-\xDF]+$/) ? true : false;
      // 全角ひらがな
      case "hiragana":
        // 全角空白もOK
        if (trimTxt == "") {
          return true;
        }
        return trimTxt.match(/^[\u3041-\u309f]+$/) ? true : false;
      // 全角カタカナ + 半角・全角空白（2023/08/28　IT2_78）
      case "katakana":
        // 全角空白もOK
        if (trimTxt == "") {
          return true;
        }
        return trimTxt.match(/^[\u30a1-\u30fc\s]+$/) ? true : false;
      // 半角英数字（大文字・小文字）
      case "alphanumeric":
        return String(input).match(/^[0-9a-zA-Z]+$/) ? true : false;
      // 半角数字
      case "numeric":
        return /^[0-9]+$/.test(String(input));
      // 符号付き整数
      case "integer":
        return (String(input).match(/^-?[0-9]+$/)) ? true : false;
      // 半角英字（大文字・小文字）
      case "alphabetic":
        return String(input).match(/^[a-zA-Z]+$/) ? true : false;
      // 半角英字（大文字のみ）
      case "upper-alphabetic":
        return String(input).match(/^[A-Z]+$/) ? true : false;
      // 半角英字（小文字のみ）
      case "lower-alphabetic":
        return String(input).match(/^[a-z]+$/) ? true : false;
      // 半角英数字（大文字・小文字）+特別な記号(._-)
      case "alphanumeric-plus-other-symbol":
        return String(input).match(/^[0-9a-zA-Z._-]+$/) ? true : false;
      // 半角英数字（大文字・小文字）+記号
      case "alphanumeric-symbol":
              return String(input).match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) ? true : false;
            // 全角数字および全角カタカナ、全角/半角空白
            case "zenkaku-numeric-katakana":
              return String(input).match(/^[\uFF10-\uFF19\u30A0-\u30FF\s\u3000]+$/) ? true : false;
    }
    return false;
  },

  /**
   * 国税禁則文字チェック
   * @param {string} input 入力値
   */
  checkNationalkinsokuchar(input) {
    // 各クォーテーション対策用
    const cuttext_a = String(input).replace("’", "");
    const cuttext_b = cuttext_a.replace("”", "");
    const cuttext_c = cuttext_b.replace("'", "");
    const cuttext_d = cuttext_c.replace('"', "");
    if (String(input).length != cuttext_d.length) {
      return false;
    }
    //　ファイル名の場合の拡張子抽出用
    let Filetext = String(input);
    // if (Filetext.lastIndexOf(".") != -1) {
    //     Filetext = this.getFileExtension(Filetext);
    // }

    //	IsBasicLatin、IsLatin-1Supplement
    //	IsGreek、IsCyrillic
    //	IsGeneralPunctuation
    //	IsNumberForms、IsArrows、IsMathematicalOperators
    //	IsEnclosedAlphanumerics、IsBoxDrawing
    //	IsGeometricShapes
    //	IsCJKSymbolsandPunctuation、IsHiragana、IsKatakana
    //	IsEnclosedCJKLettersandMonths
    //	IsCJKUnifiedIdeographs
    //	IsCJKCompatibilityIdeographs
    //	IsHalfwidthandFullwidthForms
    //	※[" ' "" ' ｦ-ﾟ]を除く
    if (
      Filetext.match(
        /\u0022|\u0027|\u8167|\u8168|\u02BA|\u02DD|\u02EE|\u030B|\u030E|\u05F4|\u201C|\u201D|\u2033|\u3003|\u02B9|\u02BC|\u02C8|\u0301|\u030D|\u05F3|\u2018|\u2019|\u2032|\uA78C|\uFF07|\uFF66-\uFF9F/
      )
    ) {
      return false;
    } else {
      // u0009、u000A、u000D、u0020～u007E　基本ラテン
      // #x00A0～#x00FF　ラテン-１補助
      // #x0370～#x03FF　基本ギリシャ
      // #x0400～#x04FF　キリール
      // #x2000～#x206F　一般句読点
      // #x2150～#x218F　数字の形
      // #x2190～#x21FF　矢印
      // #x2200～#x22FF　数学記号
      // #x2460～#x24FF　囲み英数字
      // #x2500～#x257F　罫線素片
      // #x25A0～#x25FF　幾何学模様
      // #x3000～#x303F　ＣＪＫ用の記号及び文音記号
      // #x3040～#x309F　平仮名
      // #x30A0～#x30FF　片仮名
      // #x3200～#x32FF　囲みＣＪＫ文字／月
      // #x3300～#x33FF　ＣＪＫ互換文字
      // #x4E00～#x9FFF　ＣＪＫ統合漢字
      // #xF900～#xFAFF　ＣＪＫ互換漢字
      // #xFF00～#xFF65、#xFFA0～xFFEF　半角形・全角形(半角カナを除く)
      if (
        Filetext.match(
          /^[\u0009\u000A\u000D\u0020-\u007E\u00A0-\u00FF\u0370-\u03FF\u0400-\u04FF\u2000-\u206F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2460-\u24FF\u2500-\u257F\u25A0-\u25FF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3200-\u32FF\u3300-\u33FF\u4E00-\u9FFF\uF900-\uFAFF\uFF00-\uFF65\uFFA0-\uFFEF]+$/
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },

  // **********************************************
  // ファイル名からの拡張子分の抽出
  // **********************************************
  getFileExtension(filename) {
    // get file extension
    const extension =
      filename.substring(0, filename.lastIndexOf(".")) || filename;
    return extension;
  },

  /*******************************************************************************
        詳細条件（フィルター）チェック
    *******************************************************************************/
  /**
   * 日付(開始・終了なし)　年月日項目
   * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
   * @param {*} yearSSelected 年号（開始）
   * @param {*} yearS 年（開始）
   * @param {*} monthS 月（開始）
   * @param {*} dayS 日（開始）
   * @param {*} yearESelected 年号（終了）
   * @param {*} yearE 年（終了）
   * @param {*} monthE 月（終了）
   * @param {*} dayE 日（終了）
   * @param {*} label 項目名
   * @returns チェック結果（正常：空白／異常：エラーメッセージ）
   */
  checkFilterDateYMD(
    selected,
    yearSSelected,
    yearS,
    monthS,
    dayS,
    yearESelected,
    yearE,
    monthE,
    dayE,
    label
  ) {
    var rtnS = this.checkFilterDate(
      selected,
      yearSSelected,
      yearS,
      monthS,
      dayS,
      label
    );
    if (rtnS != "") {
      return rtnS;
    }
    var rtnE = this.checkFilterDate(
      selected,
      yearESelected,
      yearE,
      monthE,
      dayE,
      label
    );
    if (rtnE != "") {
      return rtnE;
    }
    var dateS = new Date(warekiToYear(yearSSelected, yearS), monthS, dayS);
    var dateE = new Date(warekiToYear(yearESelected, yearE), monthE, dayE);
    if (dateS > dateE) {
      return Common.createError(
        "MTCL1046",
        Common.getMessage("MTCL1046", [label])
      );
    }
    return "";
  },

  /**
   * 日付(開始・終了なし)　月日項目
   * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
   * @param {*} monthS 月（開始）
   * @param {*} dayS 日（開始）
   * @param {*} monthE 月（終了）
   * @param {*} dayE 日（終了）
   * @param {*} label 項目名
   * @returns チェック結果（正常：空白／異常：エラーメッセージ）
   */
  checkFilterDateMD(selected, monthS, dayS, monthE, dayE, label) {
    var rtnS = this.checkFilterDate(selected, null, null, monthS, dayS, label);
    if (rtnS != "") {
      return rtnS;
    }
    if (selected == DETAIL_DURING_DATE_LIST[1].code) {
      var rtnE = this.checkFilterDate(
        selected,
        null,
        null,
        monthE,
        dayE,
        label
      );
      if (rtnE != "") {
        return rtnE;
      }
      if (Number(monthS) > Number(monthE)) {
        return "YearendStraddle";
      } else if (Number(monthS) == Number(monthE)) {
        if (Number(dayS) > Number(dayE)) {
          return "YearendStraddle";
        }
      }
    }
    return "";
  },

  /**
   * 日付(開始・終了あり)
   * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
   * @param {*} yearSelected 年号
   * @param {*} year 年
   * @param {*} month 月
   * @param {*} day 日
   * @param {*} label 項目名
   * @returns チェック結果（正常：空白／異常：エラーメッセージ）
   */
  checkFilterDate(selected, yearSelected, year, month, day, label) {
    // 「指定しない」以外の場合
    if (selected != 0) {
      // 非空、半角数字チェック
      // 年（ある場合のみ）
      if (yearSelected != null) {
        if (year == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label + "年"])
          );
        } else {
          if (!this.isNumeric(year)) {
            return Common.createError(
              "MTCL1006",
              Common.getMessage("MTCL1006", [label + "年"])
            );
          }
        }
      }
      // 月
      if (month == "") {
        return Common.createError(
          "MTCL1001",
          Common.getMessage("MTCL1001", [label + "月"])
        );
      } else {
        if (!this.isNumeric(month)) {
          return Common.createError(
            "MTCL1006",
            Common.getMessage("MTCL1006", [label + "月"])
          );
        }
      }
      // 日
      if (day == "") {
        return Common.createError(
          "MTCL1001",
          Common.getMessage("MTCL1001", [label + "日"])
        );
      } else {
        if (!this.isNumeric(day)) {
          return Common.createError(
            "MTCL1006",
            Common.getMessage("MTCL1006", [label + "日"])
          );
        }
      }

      if (yearSelected != null) {
        // 和暦→西暦
        const tmpYear = warekiToYear(yearSelected, year);
        // 月チェック
        if (!verifyMonth(month)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
        // 日付チェック
        if (!isDate(tmpYear, month, day)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
        // 和暦（平成⇔令和）閾値チェック
        if (!warekisikiiChk(yearSelected, year, month, day)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
      } else {
        // 月チェック
        if (!this.isMonth(month)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
        // 日チェック
        if (!this.isDay(day)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }

        // 月日
        if (!isDate(2000, month, day)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
      }

      //　年月日チェック（閏年含む）
      if (year != "" && month != "" && day != "") {
        if (this.checkDate(year, month, day)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
      }
    }
    return "";
  },

  /**
   * 日付以外(空白許容)
   * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
   * @param {*} input 入力値
   * @param {*} label 項目名
   * @returns チェック結果（正常：空白／異常：エラーメッセージ）
   */
  checkFilterWithSpace(selected, input, label) {
    // 指定しない、未入力以外
    if (selected != 0 && selected != 1) {
      if (input == "") {
        return Common.createError(
          "MTCL1001",
          Common.getMessage("MTCL1001", [label])
        );
      }
    }
    return "";
  },

  /**
   * 日付以外(空白非許容)
   * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
   * @param {*} input 入力値
   * @param {*} label 項目名
   * @returns チェック結果（正常：空白／異常：エラーメッセージ）
   */
  checkFilterWithOutSpace(selected, input, label) {
    // 指定しない以外
    if (selected != 0) {
      if (input == "") {
        return Common.createError(
          "MTCL1001",
          Common.getMessage("MTCL1001", [label])
        );
      }
    }
    return "";
  },

  /**
   * ファイル名有効性チェック
   * @param {*} input 入力値
   * @returns チェック結果（正常：／異常：エラーメッセージ）
   */
  CheckFileNameInvalid(input) {
    var reg = new RegExp('[\\\\/:*?"<>|]');
    if (reg.test(input)) {
      return false;
    }
    return true;
  },

  // 法人番号正確性チェック
  // 法人番号の1桁目=9-((2,4,6,8,10,12桁目の和)*2+(3,5,7,9,11,13桁目の和))/9の余り
  checkCorporateNumber(input) {
    if (input) {
      let list = input.trim().replace(/-/g, "").toString().split("");
      let evenList = list.filter((item, index) => index % 2 !== 0);
      let oddList = list.filter((item, index) => index % 2 === 0);
      delete oddList[0];
      let evenNum = eval(evenList.join("+"));
      let oddNum = eval(oddList.join("+"));
      let result = 9 - ((evenNum * 2 + oddNum) % 9);
      if (list[0] == result) {
        return true;
      } else return false;
    }
  },
  //いずれかが入力されているチェック
  //郵便番号3桁、所在地
  isOneRequired(input1, input2) {
    if (input1 && input1.length == 3) {
      return true;
    } else if (input2 && input2.length >= 2) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * ファイル名有効性チェック
   * @param {*} input 入力値
   * @returns チェック結果（正常：／異常：エラーメッセージ）
   */
  CheckFileName(input) {
    let Filetext = this.getFileExtension(input);
    //.で始まる
    if (Filetext.substring(0, 1) == ".") {
      return false;
    }
    //拡張子を含めた文字列、又は拡張子を除いた文字列が以下のいずれかに該当する。
    //　COM0、COM1、COM2、COM3、COM4、COM5、COM6、COM7
    //　COM8、COM9、LPT0、LPT1、LPT2、LPT3、LPT4、LPT5、
    //　LPT6、LPT7、LPT8、LPT9、CON、PRN、AUX、NUL、CLOCK$
    var tmps = [
      "COM0",
      "COM1",
      "COM2",
      "COM3",
      "COM4",
      "COM5",
      "COM6",
      "COM7",
      "COM8",
      "COM9",
      "LPT0",
      "LPT1",
      "LPT2",
      "LPT3",
      "LPT4",
      "LPT5",
      "LPT6",
      "LPT7",
      "LPT8",
      "LPT9",
      "CON",
      "PRN",
      "AUX",
      "NUL",
      "CLOCK$",
    ];
    for (const i in tmps) {
      const tmp = tmps[i];
      if (_.includes(tmps, Filetext)) {
        return false;
      }
    }
    return true;
  },
};

export default validation;
